import { computed, observable } from "mobx";
import type { EntityValidationRules } from "services/validationService";
import Person from "./person";

export const CompanyNameValidationRules: EntityValidationRules<LegalPerson> = {
  companyName: { required: true, isLength: { max: 45 }, prohibitedCharacters: true },
};

export const CompanyAddressValidationRules: EntityValidationRules<LegalPerson> = {
  companyAddress: { required: true, isLength: { max: 75 }, prohibitedCharacters: true },
};

export const CompanyRegistrationNumberValidationRules: EntityValidationRules<LegalPerson> = {
  companyRegistrationNumber: { isLength: { max: 20 }, prohibitedCharacters: true },
};

export default class LegalPerson extends Person {
  /**
   * Company name.
   */
  @observable
  companyName!: string;

  /**
   * Company registration number.
   */
  @observable
  companyRegistrationNumber!: string;

  /**
   * Company address.
   */
  @observable
  companyAddress!: string;

  @computed
  get rules(): EntityValidationRules<LegalPerson> {
    return {
      ...CompanyNameValidationRules,
      ...CompanyAddressValidationRules,
      ...CompanyRegistrationNumberValidationRules,
    };
  }

  @computed
  get validateCompanyName() {
    return !!this.companyRegistrationNumber || !!this.companyAddress;
  }

  @computed
  get validateAddress() {
    return !!this.companyRegistrationNumber || !!this.companyName;
  }

  @computed
  get validateCompanyRegistrationNumber() {
    return !!this.companyRegistrationNumber || !!this.companyName || !!this.companyAddress;
  }

  @computed
  get validateLegalPerson() {
    return !!this.companyAddress || !!this.companyName || !!this.companyRegistrationNumber;
  }
}
